import { useState, useEffect } from 'react';

function usePersistentStateWithDefault<T>(
  path: string[],
  key: string,
  initialValue: T,
  deleteParam: string,
  defaultValue: any,
): [T, React.Dispatch<React.SetStateAction<T>>, boolean] {
  const storageKey = `${path.join('/')}/${key}`;

  const [state, setState] = useState<T>(() => {
    const storedValue = localStorage.getItem(storageKey);
    if (storedValue !== null) {
      const parsedValue = JSON.parse(storedValue);
      if (Array.isArray(parsedValue)) {
        parsedValue.forEach((item: any) => {
          if (!(deleteParam in item)) {
            item[deleteParam] = defaultValue;
          }
        });
      } else if (!(deleteParam in parsedValue)) {
        parsedValue[deleteParam] = defaultValue;
      }
      return parsedValue;
    }
    return initialValue;
  });

  const [hasBeenRead, setHasBeenRead] = useState<boolean>(false);

  useEffect(() => {
    if (localStorage.getItem(storageKey) !== null) {
      setHasBeenRead(true);
    }
  }, [storageKey]);

  useEffect(() => {
    try {
      let stateToStore: any = Array.isArray(state) ? [...state] : { ...state };

      if (Array.isArray(stateToStore)) {
        stateToStore = stateToStore.map((item: any) => {
          const newItem = { ...item };
          delete newItem[deleteParam];
          return newItem;
        });
      } else {
        delete stateToStore[deleteParam];
      }

      const json = JSON.stringify(stateToStore);
      localStorage.setItem(storageKey, json);
    } catch (e) {
      console.error(e);
    }
  }, [storageKey, state, deleteParam]);

  return [state, setState, hasBeenRead];
}

export default usePersistentStateWithDefault;
